import React from 'react'
import panic from '../assets/panics.png'
import panic_audio from '../assets/panic_audio.png'


const VoiceCommand = () => {
  return (
    <>
      
      <section class="py-20 @container border-t border-[#e7f1f3] dark:border-[#a1e8e8] mt-10">
        <div class="flex flex-col gap-10 px-4">
            <div class="flex flex-col gap-4 text-center items-center">
                <h2 class="text-[#0d191c]  tracking-light text-[32px] font-bold leading-tight @[480px]:text-4xl @[480px]:font-black @[480px]:leading-tight @[480px]:tracking-[-0.033em] max-w-[720px]">
                    Advanced Safety Features
                </h2>
                <p class="text-[#4b8e9b] text-lg font-normal leading-normal max-w-[600px]">
                    Our next-generation tools ensure you're protected when it matters most, using the latest in voice and mobile tech.
                </p>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div class="flex flex-col lg:flex-row gap-6 p-8 bg-white rounded-3xl border border-[#cfe4e8] hover:shadow-xl transition-all group">
            <div class="flex-1 flex flex-col justify-center gap-4">
            <div class="flex items-center gap-3">
            <div class="w-12 h-12 bg-[#31a9e5] rounded-xl flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors">
            <span class="material-symbols-outlined text-3xl">mic</span>
            </div>
            <h3 class="text-[#0d191c]  text-2xl font-bold leading-tight">Voice and timed sos command </h3>
            </div>
                <p class="text-[#4b8e9b]  text-base font-normal leading-relaxed">
                    Simply speak your distress phrase to instantly time and send your live location to emergency contacts, even when your phone is locked or out of reach.
                </p>
            <div class="flex gap-1 items-end h-8">
            <div class="w-1 bg-primary rounded-full animate-pulse h-4"></div>
            <div class="w-1 bg-primary rounded-full animate-pulse h-8"></div>
            <div class="w-1 bg-primary rounded-full animate-pulse h-6"></div>
            <div class="w-1 bg-primary rounded-full animate-pulse h-3"></div>
            <div class="w-1 bg-primary rounded-full animate-pulse h-7"></div>
            <div class="w-1 bg-primary rounded-full animate-pulse h-5"></div>
            </div>
            </div>
            <div class="flex justify-center w-full lg:w-1/2 h-full">
             <div class="w-full flex justify-center mt-20">
               <img  loading='lazy'  class="object-contain h-full  lg:h-1/2 w-full"  data-alt="Beepy  phone" src={panic_audio}/>
               </div>
            </div>
            
            </div>


            <div class="flex flex-col lg:flex-row gap-6 p-8 bg-white rounded-3xl border border-[#cfe4e8]  hover:shadow-xl transition-all group">
          
            <div class="flex-1 flex flex-col justify-center gap-4">
            <div class="flex items-center gap-3">
            <div class="w-12 h-12 bg-red-600 rounded-xl flex items-center justify-center text-accent-pink group-hover:bg-accent-pink group-hover:text-white transition-colors">
            <span class="material-symbols-outlined text-3xl">emergency_home</span>
            </div>
            <h3 class="text-[#0d191c] text-2xl font-bold leading-tight">Instant Panic Alerts</h3>
            </div>
            <p class="text-[#4b8e9b]  text-base font-normal leading-relaxed">
                A high-priority notification system that bypasses "Do Not Disturb" modes to ensure your emergency contacts are notified immediately.
            </p>
        <div class="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-red-600 text-accent-pink text-xs font-bold uppercase tracking-wider text-white">
                 <span class="material-symbols-outlined text-sm ">priority_high</span> High Priority
              </div>
        </div>

        <div class="w-full lg:w-1/2  h-full  justify-center items-center text-center">
            <div class="w-full flex justify-center mt-20">
            <img loading='lazy'  class="object-contain h-1/2 self-center w-full lg:w-1/2"  data-alt="Beepy panic screen" src={panic}/>
            </div>
        
            <div class="overflow-hidden flex justify-center flex-col">
                <div class="size-10 rounded-full bg-red-600 flex items-center justify-center text-white shrink-0 self-center mt-5">
                    <span class="material-symbols-outlined text-lg">warning</span>
                </div>
                <p class="text-xs font-black text-accent-pink">SOS ALERT</p>
                <p class="text-[10px] text-[#0d191c] dark:text-white font-medium truncate">Emergency Contact Notified</p>
            </div>
       </div>
    </div>    
</div>
</div>

</section>


    </>
  )
}

export default VoiceCommand
